import nskRedShirt from '../assets/images/nsk-red-shirt.jpeg';
import nskWhiteShirt from '../assets/images/nsk-white-shirt.jpeg';
import nskGreenShirt from '../assets/images/nsk-green-shirt.jpeg';
import nskRedCap from '../assets/images/nsk-red-cap.jpeg';
import nskGreenCap from '../assets/images/nsk-green-cap.jpeg';

export const PRODUCTS = [
  {
    id: 'nsk-red-shirt',
    name: 'NSK Red Shirt',
    category: 'shirt',
    color: 'Red',
    description: 'Official NSK crew-neck tee in bold red.',
    price: 1000,
    image: nskRedShirt,
    hasSizes: true,
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 'nsk-white-shirt',
    name: 'NSK White Shirt',
    category: 'shirt',
    color: 'White',
    description: 'Official NSK crew-neck tee in clean white.',
    price: 1000,
    image: nskWhiteShirt,
    hasSizes: true,
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 'nsk-green-shirt',
    name: 'NSK Green Shirt',
    category: 'shirt',
    color: 'Green',
    description: 'Official NSK crew-neck tee in signature green.',
    price: 1000,
    image: nskGreenShirt,
    hasSizes: true,
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 'nsk-red-cap',
    name: 'Red Cap',
    category: 'cap',
    color: 'Red',
    description: 'Adjustable NSK branded cap in red.',
    price: 1000,
    image: nskRedCap,
    hasSizes: false,
  },
  {
    id: 'nsk-green-cap',
    name: 'Green Cap',
    category: 'cap',
    color: 'Green',
    description: 'Adjustable NSK branded cap in green.',
    price: 1000,
    image: nskGreenCap,
    hasSizes: false,
  },
];

// Friendly plural labels for the category filter pills.
export const CATEGORY_LABELS = {
  shirt: 'Shirts',
  cap: 'Caps',
};